import MapAdapter from './mapAdapter'

var WebMapDelegate = function(controller) {
    this.commandQueue = ''
    this.shouldPlayAudio = true

    this.controller = controller
}

WebMapDelegate.prototype.getPath = function(relativeResPath) {
    var path = '/'
    return path + relativeResPath
}

WebMapDelegate.prototype.determineDeviceType = function() {
    var useragent = navigator.userAgent
    if (useragent.indexOf('iPhone') != -1) {
        this.isIPhone = true
    }
    if (useragent.indexOf('Android') != -1) {
        this.isAndroid = true
    }
}

WebMapDelegate.prototype.initGoogleMap = function(gmap, mapZoom, mapCenter) {
    MapAdapter.map = gmap
}

WebMapDelegate.prototype.loadingCompleted = function() {
    this.controller.mapLoadingCompleted()
}

WebMapDelegate.prototype.playAudio = function(id) {
    var stop = this.controller.getStopById(id)
    if (stop.audio) {
        this.controller.playAudio(id)
    }
}

WebMapDelegate.prototype.stopAudio = function(id) {
    this.controller.stopAudio(id)
}

WebMapDelegate.prototype.stopSelected = function(wp) {
    this.controller.stopSelected(wp.id)
}

WebMapDelegate.prototype.stopEnteredEvent = function(wp) {
    if (wp.audio != '') {
        this.controller.stopEntered(wp.id)
    }
}

WebMapDelegate.prototype.stopChangedEvent = function(wpBefore, wpAfter) {}

WebMapDelegate.prototype.showStop = function(stopid) {}

WebMapDelegate.prototype.mapReady = function() {
    this.controller.mapReady()
}

export default WebMapDelegate
